module.exports = __webpack_public_path__ + "img/ic_x_circle_grey.47a9656d.svg";